import {useLocation} from "react-router-dom";

export const useAccountId = () => {
  const {search} = useLocation();
  const queryParams = new URLSearchParams(search);

  return queryParams.get("accountId") || "";
};
